import { render } from "./Invoice4TableFooter.vue?vue&type=template&id=7a91d1c1&scoped=true"
import script from "./Invoice4TableFooter.vue?vue&type=script&lang=js"
export * from "./Invoice4TableFooter.vue?vue&type=script&lang=js"

import "./Invoice4TableFooter.vue?vue&type=style&index=0&id=7a91d1c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a91d1c1"]])

export default __exports__